<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import VerifyAndChangeEmail from '@/components/verifyandchangeemail.vue';

export default {
  components: { VerifyAndChangeEmail },
  data() {
    return {
      appErrors: [],
      loggedIn: false,
      showLoginRequried: false,
    };
  },

  watch: {
    /**
     * Presentera felmeddelande för fel som uppstår
     */
    errorCaptured(err, component, info) {
      if (err.constructor.name != 'Error' || err.response == undefined) return;

      this.appErrors.push(err);

      // if(err.response.status == 401){
      //   // Visa "Logga in igen bla bla.." om man är på Mina sidor
      //   if(!this.$route.path.match(/^\/login/)){
      //     this.showLoginRequried = true;
      //     this.$store.dispatch('logout')
      //   }
      // }
    },
  },
};
</script>
